module.exports = __webpack_public_path__ + "static/media/fm-icons-Admin_area.01bed13b.svg";